// @flow
// ----------------------------------------------------------------------
// <copyright file="Izenda.CachingConfiguration.js" company="Izenda">
//  Copyright (c) 2015 Izenda, Inc.
//  ALL RIGHTS RESERVED
//
//  The entire contents of this file is protected by U.S. and
//  International Copyright Laws. Unauthorized reproduction,
//  reverse-engineering, and distribution of all or any portion of
//  the code contained in this file is strictly prohibited and may
//  result in severe civil and criminal penalties and will be
//  prosecuted to the maximum extent possible under the law.
//
//  RESTRICTIONS
//
//  THIS SOURCE CODE AND ALL RESULTING INTERMEDIATE FILES
//  ARE CONFIDENTIAL AND PROPRIETARY TRADE
//  SECRETS OF IZENDA INC. THE REGISTERED DEVELOPER IS
//  LICENSED TO DISTRIBUTE THE PRODUCT AND ALL ACCOMPANYING .NET
//  CONTROLS AS PART OF AN EXECUTABLE PROGRAM ONLY.
//
//  THE SOURCE CODE CONTAINED WITHIN THIS FILE AND ALL RELATED
//  FILES OR ANY PORTION OF ITS CONTENTS SHALL AT NO TIME BE
//  COPIED, TRANSFERRED, SOLD, DISTRIBUTED, OR OTHERWISE MADE
//  AVAILABLE TO OTHER INDIVIDUALS WITHOUT EXPRESS WRITTEN CONSENT
//  AND PERMISSION FROM IZENDA INC.
//
//  CONSULT THE END USER LICENSE AGREEMENT(EULA FOR INFORMATION ON
//  ADDITIONAL RESTRICTIONS.
//  </copyright>
// ----------------------------------------------------------------------

import { action } from 'mobx';
import DataCachingConfiguration from './Izenda.DataCachingConfiguration';
import SystemCachingConfiguration from './Izenda.SystemCachingConfiguration';

export default class CachingConfiguration {
  constructor(data: any) {
    this.dataCachingConfiguration = new DataCachingConfiguration();
    this.systemCachingConfiguration = new SystemCachingConfiguration();
    data && this.populateData(data);
    this.isDirty = false;
  }

  /**
   * Update data caching by property key
   * @param {string} key 
   * @param {Object} value 
   */
  setDataCachingValueByKey(key: string, value: any) {
    this.dataCachingConfiguration.setValueByKey(key, value);
    this.isDirty = true;
  }

  /**
   * Update system caching by property key
   * @param {string} key 
   * @param {Object} value 
   */
  setSystemCachingValueByKey(key: string, value: any) {
    this.systemCachingConfiguration.setValueByKey(key, value);
    this.isDirty = true;
  }

  /**
   * Populate data
   * @param {Object} data 
   */
  @action
  populateData(data: any) {
    this.dataCachingConfiguration.populateData(data.dataCacheSetting);
    this.systemCachingConfiguration.populateData(data.systemCacheSetting);
  }

  /**
   * Build data for saving
   */
  buildDataForSave() {
    return {
      dataCacheSetting: this.dataCachingConfiguration.buildDataForSave(),
      systemCacheSetting: this.systemCachingConfiguration.buildDataForSave()
    };
  }

  /**
   * Reset dirty status
   */
  resetDirty() {
    this.isDirty = false;
  }
}



// WEBPACK FOOTER //
// ./ui/logic/models/Izenda.CachingConfiguration.js